/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NewSupplyChainMembersFromExcelRequest } from '../../models/new-supply-chain-members-from-excel-request';

export interface NewSupplyChainMembersParseExcel$XWwwFormUrlencoded$Params {
      body?: {
'request': NewSupplyChainMembersFromExcelRequest;
}
}

export function newSupplyChainMembersParseExcel$XWwwFormUrlencoded(http: HttpClient, rootUrl: string, params?: NewSupplyChainMembersParseExcel$XWwwFormUrlencoded$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, newSupplyChainMembersParseExcel$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

newSupplyChainMembersParseExcel$XWwwFormUrlencoded.PATH = '/api/supply-chain/members/parse-excel';
